import type { DealSource, DealStatus } from '@psp-aggregator/sdk';
import sdk from '@psp-aggregator/sdk';
import { keepPreviousData } from '@tanstack/react-query';

export interface UseDealsParams {
  enabled?: boolean;
  limit?: number;
  page?: number;
  source?: DealSource;
  status?: DealStatus;
}

export const useDeals = ({
  enabled = true,
  limit = 24,
  page = 1,
  source,
  status,
}: UseDealsParams = {}) =>
  sdk.queries.useListDeals(page, limit, status, source, {
    enabled,
    placeholderData: keepPreviousData,
  });

export const usePublicProposal = (token: string) =>
  sdk.queries.useGetPublicProposal(token, { enabled: Boolean(token) });

export const useDealFunnel = () => sdk.queries.useGetAnalyticsFunnel();

export const useMyDashboard = () => sdk.queries.useGetMyDashboard();
